import { loadable } from 'utils';

export const Offer = loadable(() => import('./Offer'), {});
export const Range = loadable(() => import('./Range'), {});
export const RangeProduct = loadable(() => import('./RangeProduct'), {});
export const Voucher = loadable(() => import('./Voucher'), {});
export const VoucherSets = loadable(() => import('./VoucherSets'), {});
export const Import = {
  Ranges: loadable(() => import('./Import/Ranges'), {}),
  Offers: loadable(() => import('./Import/Offers'), {}),
};
